export default __webpack_public_path__ + "static/media/lootbox.b2c3eed7.png";